import { render, staticRenderFns } from "./PayrollList.vue?vue&type=template&id=6f1bbd23"
import script from "./PayrollList.vue?vue&type=script&lang=js"
export * from "./PayrollList.vue?vue&type=script&lang=js"
import style0 from "./PayrollList.vue?vue&type=style&index=0&id=6f1bbd23&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports